// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-ai-center[data-v-57990022]{align-items:center}label[data-v-57990022]{font-weight:500}[data-v-57990022] .p-dialog#AVWAP{width:25rem!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
